export default __webpack_public_path__ + "assets/e1b60ceae1466751e7fb36822ce550d5.png";